import authReducer from '@/pages/auth/authSlice'
import clubReducer from '@/pages/club/clubSlice'
import eventReducer from '@/pages/event/eventSlice'
import appReducer from '@/pages/home/appSlice'
import playerReducer from '@/pages/player/playerSlice'
import userReducer from '@/pages/user/userSlice'
import { combineReducers } from 'redux'
import { entitlementsReducer } from './entitlementsReducer'
import remoteConfigReducer from './remoteConfigSlice'

const RootReducers = combineReducers({
  auth: authReducer,
  user: userReducer,
  app: appReducer,
  player: playerReducer,
  club: clubReducer,
  event: eventReducer,
  entitlements: entitlementsReducer,
  remoteConfig: remoteConfigReducer,
})

export type RootState = ReturnType<typeof RootReducers>
export default RootReducers
